import { useEffect } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"

import { useAppDispatch } from "store/hooks"
import { setInitialURL } from "store/tempDataSlise"
import { StorageKeys } from "types/enums/StorageKeys"

import { getStorageItem } from "utils/localStorage"
import { parseQueryString } from "utils/parseQueryString"
import { useLoadFeatureFlags } from "hooks/useLoadFeatureFlags"

export const PrivateRoute = () => {
  const location = useLocation()

  useLoadFeatureFlags()

  useEffect(() => {
    // For the technician "add device flow"
    if (location?.pathname === "/add-device/customer" && location?.search !== "") {
      const result = parseQueryString(location?.search)

      if (result?.sn) {
        sessionStorage.setItem(StorageKeys.TechnicianSN, JSON.stringify(result?.sn))
      }
    }
  }, [location])

  // const onLogOut = () => {
  //   sessionStorage.clear();
  //   window.location.reload();
  // };

  const checkCredentials = () => {
    const dispatch = useAppDispatch()
    const tokenStorage = getStorageItem(StorageKeys.Token)

    if (!tokenStorage) {
      if (location?.pathname !== "/" && !location?.pathname.startsWith("/auth")) {
        dispatch(setInitialURL(`${location?.pathname}${location?.search}`))
      }

      return false
    }

    // TO-DO:
    // 1) check session time
    // 2) logout if session time is expired
    // toast.error("You have been signed out, time expired");

    return true
  }

  return checkCredentials() ? <Outlet /> : <Navigate to="/auth/sign-in" />
}
